import React from 'react';
import { useStateContext } from '../../../../context/ContextProvider';
import { PiSwimmingPool, PiSwimmingPoolDuotone, PiSwimmingPoolThin, PiTreeEvergreen } from 'react-icons/pi';
import { CgGym } from 'react-icons/cg';
import { IoCafeOutline, IoCarSportOutline, IoGolfOutline, IoShieldHalf } from 'react-icons/io5';
import { MdOutlineBeachAccess, MdOutlineSports, MdOutlineSportsTennis } from 'react-icons/md';
import { GrYoga } from 'react-icons/gr';
import ColorLandingPage from '../../../LandingPages/ColorLandingPage';

function NinaOneLaguna({
    language
}) {
    const images = [
        "/assets/images/projects/one-laguna/1.webp",
        "/assets/images/projects/one-laguna/2.webp",
        "/assets/images/projects/one-laguna/3.webp",
        "/assets/images/projects/one-laguna/4.webp"
    ];

    const poster = "/assets/images/projects/one-laguna/1.webp";
    // const webm = "/assets/images/projects/azizi-milan/hero.webm";
    const video = "/assets/images/projects/one-laguna/one-laguna.mp4";

    const amenityDetails = [
        {
            // "icon": "/assets/images/icons/pool.svg",
            "icon": <PiSwimmingPool size={60} className="text-orange-400/50" />,
            "en_text": "Swimming Pool",
            "ar_text": "مسبح بانورامي",
        },
        {
            // "icon": "/assets/images/icons/gym.svg",
            "icon": <CgGym size={60} className="text-orange-400/50" />,
            "en_text": "Fully Equipped Gym",
            "ar_text": "نادي صحي مجهز",
        },
        {
            // "icon": "/assets/images/icons/restaurant.svg",
            "icon": <IoCafeOutline size={60} className="text-orange-400/50" />,
            "en_text": "Restaurants & Cafés",
            "ar_text": "كافيهات ومطاعم راقية",
        },
        {
            // "icon": "/assets/images/icons/greenary.svg",
            "icon": <PiTreeEvergreen size={60} className="text-orange-400/50" />,
            "en_text": "Gardens & Green Spaces",
            "ar_text": "حدائق ومساحات خضراء",
        },
        {
            // "icon": "/assets/images/icons/parking.svg",
            "icon": <IoCarSportOutline size={60} className="text-orange-400/50" />,
            "en_text": "Covered Parking",
            "ar_text": "مواقف سيارات مغطاة",
        },
        {
            // "icon": "/assets/images/icons/security.svg",
            "icon": <IoShieldHalf size={60} className="text-orange-400/50" />,
            "en_text": "24/7 Security",
            "ar_text": "أمن وحراسة على مدار الساعة",
        },
        {
            // "icon": "/assets/images/icons/security.svg",
            "icon": <MdOutlineBeachAccess size={60} className="text-orange-400/50" />,
            "en_text": "Beach",
            "ar_text": "شاطئ رملي خاص",
        },
        {
            // "icon": "/assets/images/icons/security.svg",
            "icon": <IoGolfOutline size={60} className="text-orange-400/50" />,
            "en_text": "Golf course",
            "ar_text": "ملاعب جولف",
        },
        {
            // "icon": "/assets/images/icons/security.svg",
            "icon": <MdOutlineSportsTennis size={60} className="text-orange-400/50" />,
            "en_text": "Tennis Court",
            "ar_text": "ملاعب تنس",
        },
        {
            // "icon": "/assets/images/icons/security.svg",
            "icon": <GrYoga size={60} className="text-orange-400/50" />,
            "en_text": "Fitness and Yoga Center",
            "ar_text": "يوجا",
        }
    ];

    const {
        langs,
        langCode,
        userInfo,
        FINDESTATES_URL,
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const isUAE = userInfo?.countryName == "United Arab Emirates";
    const isIraq = userInfo?.countryName == "Iraq";
    const isIran = userInfo?.countryName == "Iran";
    const isTurkey = userInfo?.countryName == "Turkey";
    const isUSA = userInfo?.countryName == "United States";
    const isCanada = userInfo?.countryName == "Canada";

    const Heading = () => {
        return (
            <>
                {/* {language == "ar" ? ( */}
                <h1 className="text-center text-xl lg:text-2xl font-bold neon-white">
                    <span className="text-orange-300 neon-orange">
                        {/* الوحدات محدودة .. */}
                        استلم شقتك مفروشة بالكامل
                    </span>
                    <br />
                    &nbsp;
                    {/* سجل بياناتك الأن */}
                    العرض لمدة 3 أيام فقط
                </h1>
                {/* // ) : (
                //     <h1 className="font-bold text-center text-xl">
                //         Your opportunity to own property in the heart of Dubai
                //         <br />
                //         with installments of
                //         <span className="text-2xl text-orange-300 neon-orange">AED 5800</span>
                //         only
                //         <br />
                //         Register your details and we will send you the information
                //     </h1>
                // )} */}

            </>
        );
    }

    const gridDetails = [
        {
            "topic": "أنواع الوحدات",
            "text": "استوديو 3,2,1 غرفة",
        },
        {
            "topic": "الأسعار تبدأ من",
            "text": isUAE ? "790,000 درهم" : "215 ألف دولار",
        },
        {
            "topic": "أقساط شهرية",
            "text": isUAE ? "7900 درهم" : "2150 دولار",
        },
    ];

    const imageDetails = {
        "title": "✨ عرض حصري لفترة محدودة ✨",
        "desc": "احجز وحدتك الآن واستلم شقتك مفروشة بالكامل مع سنة صيانة مجانية"
    };

    return (
        <>
            {/* LANGUAGE */}
            {/* <LanguageNavigate
                    support={["en", "ar", "fa", "tr"]}
                    redirect={{
                        en: "/projects/azizi/milan",
                        ar: "/projects/azizi/milan/ar",
                        fa: "/projects/azizi/milan/fa",
                        tr: "/projects/azizi/milan/tr",
                    }}
                /> */}
            <ColorLandingPage
                color={"orange"}
                // language={language}
                poster={poster}
                video={video}
                images={images}
                heading={<Heading />}
                gridDetails={gridDetails}
                imageDetails={imageDetails}
                amenityDetails={amenityDetails}
                projectName={""}
                base_url={FINDESTATES_URL}
                developer="One"
                project="Laguna"
                leadType="Apartment"
                language={language === "ar" ? "Arabic" : language === "fa" ? "Farsi" : language === "tr" ? "Turkish" : "English"}
                enquiries={["Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms"]}
                // assignedToManager={language == "fa" ? 120 : null}
                // assignedToSales={language == "fa" ? 518 : null}
                contactTime={isUSA || isCanada ? true : false}
                otpCode={6}
            />
        </>
    );
}

export default NinaOneLaguna;
